<flex-column adEl [gap]="0" fitContent>
  <div adEl="parentBanner" class="parent-banner">
    <span adEl>A product of </span>
    <a
      adEl
      href="https://apexbpm.com"
      target="_blank"
      style="color: #4ad9ff; text-decoration: none; font-weight: 600"
      >Apex Process Consultants</a
    >
    <span adEl> — 17 years of process automation consulting + delivery</span>
  </div>
  <nav adEl="navbar" class="marketing-nav">
    <div adEl="navLeft" class="nav-left">
      <a adEl="logo" routerLink="/" class="logo">
        <span adEl>Apex </span>
        <span adEl style="color: #513bb3">Designer</span>
        <span
          adEl
          style="
            font-size: 11px;
            font-weight: 600;
            color: #4ad9ff;
            vertical-align: super;
            margin-left: 2px;
          "
          >3</span
        >
      </a>
    </div>
    <div adEl="navRight" class="nav-right">
      <button
        adEl="loginBtn"
        mat-stroked-button
        (click)="login()"
        style="
          --mat-button-outlined-label-text-color: #513bb3;
          --mat-button-outlined-outline-color: #513bb3;
          --mat-button-outlined-container-shape: 4px;
          display: none;
        "
      >
        Login
      </button>
    </div>
  </nav>
  <div adEl="content">
    <router-outlet adEl></router-outlet>
  </div>
  @if (!isLoginPage) {
  <footer adEl="footer" class="marketing-footer">
    <flex-column adEl="footerInner" [gap]="24" fitContent class="footer-inner">
      <flex-row adEl="footerTop" [gap]="40" [fitContent]="true">
        <flex-column adEl="brand" [gap]="4" fitContent grow>
          <div
            adEl="footerLogo"
            style="
              font-family: 'Montserrat', sans-serif;
              font-weight: 700;
              font-size: 18px;
              color: #0c1726;
              letter-spacing: -0.3px;
            "
          >
            <span adEl>Apex </span>
            <span adEl style="color: #513bb3">Designer</span>
            <span
              adEl
              style="
                font-size: 11px;
                font-weight: 600;
                color: #4ad9ff;
                vertical-align: super;
                margin-left: 2px;
              "
              >3</span
            >
          </div>
          <p adEl style="font-size: 13px; color: #6b7280; margin: 0">
            <span adEl>by </span>
            <a
              adEl
              href="https://apexbpm.com"
              target="_blank"
              style="color: #0c1726; font-weight: 600; text-decoration: none"
              >Apex Process Consultants</a
            >
          </p>
        </flex-column>
        <flex-column adEl="companyCol" [gap]="6" fitContent class="footer-col">
          <h5 adEl>COMPANY</h5>
          <a adEl="fcApex" href="https://apexbpm.com" target="_blank"
            >Apex Process Consultants</a
          >
          <a adEl="fcBlog" href="https://apexbpm.com/blog/" target="_blank"
            >Blog</a
          >
          <a
            adEl="fcContact"
            href="https://apexbpm.com/company/contact"
            target="_blank"
            >Contact</a
          >
        </flex-column>
      </flex-row>
      <flex-row
        adEl="footerBottom"
        style="
          padding-top: 20px;
          border-top: 1px solid #f0f0f0;
          font-size: 12px;
          color: #9ca3af;
          justify-content: space-between;
          align-items: center;
        "
      >
        <span adEl
          >2000 Town Center, Suite 1900, Southfield, MI 48075 ·
          info&#64;apexdesigner.com · (313) 364-0039</span
        >
      </flex-row>
    </flex-column>
  </footer>
  }
</flex-column>
